module.exports = __webpack_public_path__ + "b8c49b9397ff3e9e0dbfdb5c395eedb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/6_column_large_x1/public/games/sm_image_1.jpg
// module id = 488
// module chunks = 0